import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { useState } from "react";
import { addLacreRodoviario, removerLacreRodoviario } from "../../../features/manifestoSlice";
import { LacreInterface } from "../../../interfaces";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { getPseudoID } from "../../../utils/utils";
import { JConfirmDelete, MensagemModal } from "../../../components/Components";

const initialForm: LacreInterface = {
    id: 0,
    numero: ''
}

export default function LacresRodoviario() {
    const dispatch = useDispatch();
    const listaLacres = useSelector((state: RootState) => state.manifesto.manifesto.modal_rodoviario.lacres);
    const [form, setForm] = useState<LacreInterface>(initialForm);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selected, setSelected] = useState<number>(0);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(0);
    }

    const handleOpenModal = (id: number) => {
        setSelected(id);
        setShowModal(true);
    }

    const validarPreenchimento = () => {

        if (form.numero.trim() === "") {
            alerta('Informe o número do lacre.')
            return false;
        }

        if (listaLacres.find((item: LacreInterface) => item.numero === form.numero)) {
            alerta('Número do lacre já foi adicionado.')
            return false;
        }

        return true;
    }

    const handleAdd = () => {
        if (validarPreenchimento()) {
            dispatch(addLacreRodoviario({
                id: getPseudoID(),
                numero: form.numero
            }));
            setForm(initialForm);
        }
    }

    const handleRemover = (id: number) => {
        dispatch(removerLacreRodoviario(id));
        setShowModal(false);

    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    return (<>

        <Row className="mb-3 g-2">
            <Col md={'auto'}>
                <Form.Group>
                    <Form.Label>Número do lacre</Form.Label>
                    <Form.Control maxLength={60} type="text"
                        value={form.numero} name="numero" onChange={handleChange} />
                </Form.Group>
            </Col>

            <Col md={'auto'} className="align-self-end">
                <Form.Group >
                    <Button variant="primary"
                        onClick={handleAdd}><FontAwesomeIcon icon={faPlus} />  Adicionar
                    </Button>
                </Form.Group>
            </Col>
        </Row>

        <Table striped bordered hover size="sm">
            <thead className="table-light">
                <tr>
                    <th className="text-center" style={{ width: '2.5rem' }}>#</th>
                    <th>Número do lacre</th>
                </tr>
            </thead>

            <tbody>
                {listaLacres.map((item: LacreInterface) => (
                    <tr key={item.id}>
                        <td className="text-center">
                            <Link to={''} className="text-danger" onClick={() => handleOpenModal(item.id)}>
                                <FontAwesomeIcon icon={faTrash} />
                            </Link>
                        </td>
                        <td>{item.numero}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemover}
            selectedObject={listaLacres.find((item: LacreInterface) => item.id === selected)?.numero}
            id={selected}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}
